module.exports = __webpack_public_path__ + "static/media/map.edb2a207.svg";